const UPSELL_TOGGLE_STORAGE_PREFIX = 'upsell-toggle-source-product';
const UPSELL_TOGGLE_STORAGE_EVENT = 'upsell-toggle-source-product-change';

function getUpsellToggleStorageKey(destinationHandle, sourceHandle) {
  return `${UPSELL_TOGGLE_STORAGE_PREFIX}:${destinationHandle}:${sourceHandle}`;
}

export function storeUpsellToggleSourceProduct({
  destinationHandle,
  sourceProduct
}) {
  const sourceHandle = sourceProduct?.shopifyProduct?.[0]?.handle;
  if (
    typeof window === 'undefined' ||
    !destinationHandle ||
    !sourceHandle ||
    !sourceProduct?.url
  ) {
    return;
  }

  try {
    window.sessionStorage.setItem(
      getUpsellToggleStorageKey(destinationHandle, sourceHandle),
      JSON.stringify(sourceProduct)
    );
    window.dispatchEvent(
      new CustomEvent(UPSELL_TOGGLE_STORAGE_EVENT, {
        detail: {
          key: getUpsellToggleStorageKey(destinationHandle, sourceHandle)
        }
      })
    );
  } catch (error) {
    console.warn('Unable to store upsell toggle source product.', error);
  }
}

export function getUpsellToggleSourceProductSnapshot({
  destinationHandle,
  sourceHandle
}) {
  if (typeof window === 'undefined' || !destinationHandle || !sourceHandle) {
    return null;
  }

  try {
    return window.sessionStorage.getItem(
      getUpsellToggleStorageKey(destinationHandle, sourceHandle)
    );
  } catch (error) {
    console.warn('Unable to read upsell toggle source product.', error);
    return null;
  }
}

export function subscribeToUpsellToggleSourceProduct(
  { destinationHandle, sourceHandle },
  listener
) {
  if (typeof window === 'undefined') return () => {};

  const key = getUpsellToggleStorageKey(destinationHandle, sourceHandle);
  const handleStorageChange = (event) => {
    if (event.type === 'storage' && event.key !== key) return;
    if (
      event.type === UPSELL_TOGGLE_STORAGE_EVENT &&
      event.detail?.key !== key
    ) {
      return;
    }
    listener();
  };

  window.addEventListener('storage', handleStorageChange);
  window.addEventListener(UPSELL_TOGGLE_STORAGE_EVENT, handleStorageChange);

  return () => {
    window.removeEventListener('storage', handleStorageChange);
    window.removeEventListener(
      UPSELL_TOGGLE_STORAGE_EVENT,
      handleStorageChange
    );
  };
}

export function getUpsellToggleSourceProduct({
  destinationHandle,
  sourceHandle,
  serializedSourceProduct = getUpsellToggleSourceProductSnapshot({
    destinationHandle,
    sourceHandle
  })
}) {
  if (!destinationHandle || !sourceHandle || !serializedSourceProduct) {
    return null;
  }

  try {
    const parsedSourceProduct = JSON.parse(serializedSourceProduct);
    return parsedSourceProduct?.shopifyProduct?.[0]?.handle === sourceHandle
      ? parsedSourceProduct
      : null;
  } catch (error) {
    console.warn('Unable to parse stored upsell toggle source product.', error);
    return null;
  }
}
